document.querySelectorAll('.InfrastructureRc').forEach((form) => {
    const input = form.querySelector('.InfrastructureRc__form input');
    const titleVal = form.querySelector('.InfrastructureRc__title span');
    const itemsEl = form.querySelector('.InfrastructureRc__items');
    if(!itemsEl) return;
    const url = itemsEl.dataset.url;

    input.addEventListener('input', () => {
        titleVal.innerHTML = input.value;
        itemsEl.classList.add('InfrastructureRc__items--hide');
        debounceUpdate(input.value);
    });

    const debounceUpdate = debounce((value) => {
       fetch(`${url}?time=${value}`).then((r) => r.text()).then((html) => {
          itemsEl.innerHTML = html;
          if(itemsEl.dataset.random) {
              const count = randomInteger(1, 10);
              for (let i = 0; i < count; i++) {
                  const i = randomInteger(0, itemsEl.childElementCount-1);
                  itemsEl.children[i].remove();
              }
          }
          itemsEl.classList.remove('InfrastructureRc__items--hide');
       });
    }, 1000);
})
